import Layout from '@/views/scheduler/Layout.vue';

export default {
    path: '/scheduler',
    component: Layout,
    children: [
        { path: 'crons', component: () => import('@/views/scheduler/Crons.vue') },
    ]
};
